module.exports = __webpack_public_path__ + "assets/img/img-chara-maintenance.9e1a082c.svg";